import React from 'react'

export default function TextItems ({ children }) {
  return (<div className={'lc-text-items'}>{children}</div>)
}

TextItems.TextItem = ({ children }) => <div className={'lc-text-item'}>{children}</div>
TextItems.TextLeft = ({ children }) => <div className={'lc-text-item__left'}>{children}</div>
TextItems.TextRight = ({ children }) => <div className={'lc-text-item__right'}>{children}</div>
